import { render, staticRenderFns } from "./SuggestsAlertDelete.vue?vue&type=template&id=9e9bb406&scoped=true"
import script from "./SuggestsAlertDelete.vue?vue&type=script&lang=js"
export * from "./SuggestsAlertDelete.vue?vue&type=script&lang=js"
import style0 from "./SuggestsAlertDelete.vue?vue&type=style&index=0&id=9e9bb406&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9bb406",
  null
  
)

export default component.exports